import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Flame } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/_guest')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (session.authenticated) throw redirect({ to: '/' });
  },
  component: GuestLayout,
});

function GuestLayout() {
  const { data } = useQuery(sessionQuery);
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden px-4 py-12">
      {/* A faint grid behind the card; decorative only. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)] opacity-60"
        style={{
          backgroundImage:
            'linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
      <main className="relative w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <span className="bg-card text-brand shadow-card grid size-11 place-items-center rounded-xl border">
            <Flame className="size-5" aria-hidden />
          </span>
          <p className="text-lg font-semibold tracking-tight">{data?.panel.name ?? 'Hearth'}</p>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
